import { useSelector } from "react-redux";
import { BasicLayout } from "../../modules/Layouts/basicLayout";
import BasicHeaderDocumentos from "./Components/BasicHeader";
import FormulariosNR from "./Components/NotaRemision/FormulariosNR";
import { State } from "../../reducers";
import { useEffect } from "react";
import useNotaRemision from "../../actions/nota-remision.actions";
import BasicFooterDocumentos from "./Components/BasicFooterDocument";
import ModalDelete from "../../components/Modals/Generales/ModalDelete";
import ModalEditarProducto from "./Components/NotaRemision/ModalEditarProducto";
import DTENotaRemision from "./Components/DTE/DTENotaRemision";
import ModalConfirm from "../../components/Modals/Generales/ModalConfirm";
import ModalDTEEmitido from "./Components/ModalDTEEmitido";
import ModalSendEmailDTE from "./Components/ModalSendEmailDTE";
import ModalImprimirFactura from "../../components/Modals/ModalsFacturacion/ModalImprimirFactura";
import ModalAnularDTE from "./Components/ModalAnularDTE";
import ModalClienteEncontradoDTE from "./Components/BasicModalClienteEncontradoDTE";
import ModalBuscarDocumentoDTE from "./Components/NotaRemision/ModalBuscarDocumentoDTE";
import ModalSalir from "../../components/Modals/Generales/ModalConfirmSalir";
import ModalProductoNR from "./Components/NR/ModalProductoNR";
import ModalEditarProductoNR from "./Components/NR/ModalEditarProductoNR";
import { unirChipsArray } from "../../utils/strings.utils";

export default function NotaRemision (){
    const {
        view, 
        formCliente, 
        modal_quitarTodo,
        modal_editar,
        modal_eliminar,
        modal_emitir,
        modal_emitido,
        modal_masOpciones,
        modal_enviarCorreo,
        modal_imprimir,
        modal_anulado,
        modal_asociarDocumentosWarning,
        modal_anular,
        modal_clienteEncontrado,
        modal_buscarDocumentos,

        productoEdit,
        clienteEncontrado,

        errorsProducto,
        response_QRcode,
        response_Emitir,
        asociarDocumentos,

        formBusquedaDocumento,
        errorsFormBusquedaDocumento,
        documentosEncontrados,
        documentosAsociados,
        loader_asociarDocumentos,
        mostrarDetalle,
        modal_agregarProductoFisico,
        modal_editarProductoFisico
    } = useSelector((state: State) => state.notaRemision)
    const {
        cargarSucursales, 
        footer_textButtons, 
        footer_onClickBack, 
        footer_onClickNext, 
        button_onClickQuitarTodo, 
        modal_cerrarQuitarTodo,
        modal_cerrarModalEliminar,

        modal_onChangeFormProductoEdit,
        modal_onChangeSelectCatalogoProductoEdit,
        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_cerrarModalEditar,
        modal_cerrarEmitir,

        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_cerrarMasOpciones,
        modal_button_cerrarModalEmitido,
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,

        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_cerrarImprimir,

        modal_button_anular,
        modal_cerrarAnular,
        modal_button_onConfirmAnular,

        modal_cerrarClienteEncontrado,
        modal_button_aceptarClienteEncontrado,
        button_modalConfirmChangeAsociarDocumentos,
        modal_button_closeWarningAsociarDocumentos,
        onChangeFormBusquedaDocumento,
        buscarDocumentosAsociados,
        modal_button_descargarJson,

        actionButton_asociar,
        actionButton_desasociar,
        buttonActiveModalBusquedaDocumentos,
        modal_button_limpiarFormBusquedaDocumento,
        modal_button_imprimirTicket,
        modal_button_descargarPDFTicket,
    } = useNotaRemision()

    const { config } = useSelector((state: State) => state.userLogin)

    return (
        <BasicLayout>
            <ModalSalir 
                excludeValidate={formCliente.loadedSucursal && (!formCliente.datosSucursal || formCliente.datosSucursal?.length == 0)} 
                title="Salir de nota de remisión" 
                onConfirmExit={modal_button_emitirNuevo}
            />
            {(modal_emitido || modal_masOpciones) && 
                <ModalDTEEmitido 
                    title = {modal_masOpciones ? 'Más opciones' : '¡Nota de remisión emitida!'}
                    onClickNuevo={modal_button_emitirNuevo}
                    onClickAnular={modal_button_anular}
                    onClickCerrar={modal_masOpciones ? modal_cerrarMasOpciones : modal_button_cerrarModalEmitido}
                    onClickDownloadExcel={modal_button_descargarExcel}
                    onClickDownloadImage={modal_button_descargarImagen}
                    onClickDownloadPDF={modal_button_descargarPDF}
                    onClickEmail={modal_button_enviarCorreo}
                    onClickPrint={modal_button_imprimir}
                    onClickVerDetalle={modal_button_verDetalle}
                    onClickDownloadJson={modal_button_descargarJson}
                    verDetalle = {!modal_masOpciones}
                    qrImage={response_QRcode}
                    ticketHabilitado={config?.tickethabilitado}
                    onClickPrintTicket={modal_button_imprimirTicket}
                    onClickDownloadPDFTicket={modal_button_descargarPDFTicket}
                />
            }
            {modal_imprimir && <ModalImprimirFactura ocultarPrecio={!mostrarDetalle} documento={response_Emitir?.JsonFactura} sello={response_Emitir?.Sello} modoTicket={config?.tickethabilitado === true} onCancel={modal_cerrarImprimir} onPrint={modal_cerrarImprimir}/>}
            {modal_enviarCorreo && <ModalSendEmailDTE chipsEmail={unirChipsArray(formCliente.chipsEmail, formCliente.email)} onClickBack={modal_button_cerrarEnviarCorreo} onClickSend={modal_button_onClickEnviarCorreo}/>}
            {modal_emitir && <ModalConfirm title = 'Emitir nota de remisión' detail = 'Estás a punto de emitir esta nota de remisión ¿deseas continuar?' closeModalConfirm = {modal_cerrarEmitir} actionConfirm = {modal_button_emitirDocumento} messageAction = 'Emitir'/>}
            {modal_eliminar && <ModalDelete title = 'Quitar producto' detail = '¿Seguro que quieres quitar este producto? Esta acción no se puede deshacer.' closeModalDelete = {modal_cerrarModalEliminar} actionDelete = {modal_button_onConfirmEliminar}/>}
            {modal_editar && <ModalEditarProducto dteCode="04" desactivarExento desactivarSwitch notaRemision = {asociarDocumentos} errors = {errorsProducto} formProducto = {productoEdit} onChangeFormProducto = {modal_onChangeFormProductoEdit} onChangeSelectCatalogoProducto={modal_onChangeSelectCatalogoProductoEdit} onClickCerrarModalEditarProducto = {modal_cerrarModalEditar} onClickActualizarProducto = {modal_button_onConfirmEdit}/>}
            {modal_quitarTodo && <ModalDelete title = 'Quitar todo' detail = '¿Seguro que quieres quitar todos los productos de esta lista? Esta acción no se puede deshacer.' actionDelete = {button_onClickQuitarTodo} closeModalDelete = {modal_cerrarQuitarTodo}/>}
            {modal_anular && <ModalAnularDTE title="Anular nota de remisión" warning='Estás a punto de anular esta nota de remisión ¿deseas continuar?' onCancel={modal_cerrarAnular} actionConfirm={modal_button_onConfirmAnular}/>}
            {modal_clienteEncontrado && <ModalClienteEncontradoDTE infoCliente = {clienteEncontrado} onClickCancel = {modal_cerrarClienteEncontrado} onClickConfirm = {modal_button_aceptarClienteEncontrado}/>}
            {modal_asociarDocumentosWarning && <ModalConfirm title = {asociarDocumentos ? 'Documentos asociados y productos' : 'Productos'} detail = {`Advertencia: al realizar esta acción eliminarán todos los ${asociarDocumentos ? 'documentos asociados y sus' : ''} productos previamente agregados ¿Deseas continuar?`} closeModalConfirm = {modal_button_closeWarningAsociarDocumentos} actionConfirm = {button_modalConfirmChangeAsociarDocumentos}/>}
            {modal_buscarDocumentos && <ModalBuscarDocumentoDTE onClickLimpiarForm={modal_button_limpiarFormBusquedaDocumento} onClickCerrar = {() => buttonActiveModalBusquedaDocumentos(false)} loader = {loader_asociarDocumentos} buttonAsociar = {actionButton_asociar} buttonDesasociar = {actionButton_desasociar} asociados = {documentosAsociados} resultados={documentosEncontrados} form={formBusquedaDocumento} errors={errorsFormBusquedaDocumento} onChange={onChangeFormBusquedaDocumento} onClickSearch={buscarDocumentosAsociados}/>}
            {modal_agregarProductoFisico && <ModalProductoNR />}
            {modal_editarProductoFisico && <ModalEditarProductoNR errors = {errorsProducto} formProducto = {productoEdit} documentosAsociados={documentosAsociados} onChangeFormProducto = {modal_onChangeFormProductoEdit} onClickCerrarModalEditarProducto = {modal_cerrarModalEditar} onClickActualizarProducto = {modal_button_onConfirmEdit}/>}
            <BasicHeaderDocumentos title="Nota de remisión" url="/otros-documentos"/>
            {renderView(view)}  
            <BasicFooterDocumentos textBack={footer_textButtons().back.text} imgBack={footer_textButtons().back.icon} textNext={footer_textButtons().next.text} imgNext={footer_textButtons().next.icon} onClickBack={footer_onClickBack} onClickNext={footer_onClickNext}/>          
        </BasicLayout>
    )
}

const renderView = (view: string) => {
    switch(view){
        case 'Formularios':
            return <FormulariosNR/>
        case 'Previsualizacion':
        case 'Detalle':
            return <DTENotaRemision/>
    }
}